import { render, staticRenderFns } from "./IconEmail.vue?vue&type=template&id=1ff247a5"
import script from "./IconEmail.vue?vue&type=script&setup=true&lang=ts"
export * from "./IconEmail.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports